import { render, staticRenderFns } from "./CourseReviewTab.vue?vue&type=template&id=b70d11a8&scoped=true"
import script from "./CourseReviewTab.vue?vue&type=script&lang=js"
export * from "./CourseReviewTab.vue?vue&type=script&lang=js"
import style0 from "./CourseReviewTab.vue?vue&type=style&index=0&id=b70d11a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70d11a8",
  null
  
)

export default component.exports